import React from "react";

import s from "./PatientFileReference.module.css";

/*
 * The expanded body of one reference section. An empty list says so in words —
 * a blank area would read as "not loaded" to anyone who has seen this panel
 * fail. Failures never reach here: they replace the whole section at panel
 * level, so nothing in this component can present a failed fetch as "nothing
 * recorded".
 *
 * Entries are never truncated. The list scrolls inside a fixed height instead,
 * so fifteen medications cannot push the form's Add button off the screen while
 * still leaving every one of them reachable; the count in the heading says how
 * many there are to scroll through.
 */
export const ReferenceList = ({ entries, isLoading, emptyText }) => (
  <div className={s.body}>
    {!!isLoading && (
      <p className={s.status} data-testid="reference-list-loading">
        Loading…
      </p>
    )}

    {!isLoading && !entries.length && (
      <p className={s.status} data-testid="reference-list-empty">
        {emptyText}
      </p>
    )}

    {!isLoading && !!entries.length && (
      <ul className={s.list}>
        {entries.map((entry) => (
          <li key={entry.id} className={s.item}>
            <span className={s.itemPrimary}>{entry.primary}</span>
            {!!entry.secondary && (
              <span className={s.itemSecondary}>{entry.secondary}</span>
            )}
          </li>
        ))}
      </ul>
    )}
  </div>
);
